import { MessageSystem } from '@halo/ui-chat-react';
import { MsgItem } from '../../msg-parts';
import type { MsgGroupInviteContentProps } from './msg-group-invite-content';
import { MsgGroupInviteContent } from './msg-group-invite-content';

export interface MsgGroupInviteProps extends MsgGroupInviteContentProps {}

export const MsgGroupInvite = memo(function MsgGroupInvite({ message }: MsgGroupInviteProps) {
  return (
    <MsgItem message={message}>
      <MessageSystem>
        <MsgGroupInviteContent message={message} />
      </MessageSystem>
    </MsgItem>
  );
});
